var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddsubcategoryImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 376,
    height: 273,
    viewBox: "0 0 376 273",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_537_39157)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M91.8945 1.10938H33.1996C28.9599 1.10938 25.1607 3.69118 23.608 7.61333L18.3772 20.819H106.706L101.475 7.61333C99.9224 3.69118 96.1232 1.10938 91.8945 1.10938Z",
    fill: "#0A525A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.542 1.10938H199.847C195.618 1.10938 191.808 3.69118 190.255 7.61333L185.025 20.819H273.353L268.122 7.61333C266.581 3.69118 262.771 1.10938 258.542 1.10938Z",
    fill: "#45A4AE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.748 19.3578H189.451L184.804 7.61333C183.252 3.69118 179.452 1.10938 175.213 1.10938H116.518C112.289 1.10938 108.479 3.69118 106.926 7.61333L102.279 19.3578H16.5601C9.94182 19.3578 4.51282 24.7631 4.51282 31.3769V260.685C4.51282 267.288 9.93081 272.705 16.5601 272.705H361.748C368.366 272.705 373.795 267.299 373.795 260.685V31.3769C373.795 24.7741 368.377 19.3578 361.748 19.3578Z",
    fill: "#0D8390"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.076 260.916V53.9983C366.076 51.7351 364.237 49.9004 361.968 49.9004L16.3289 49.9004C14.0604 49.9004 12.2213 51.7351 12.2213 53.9983V260.916C12.2213 263.18 14.0604 265.014 16.3289 265.014H361.968C364.237 265.014 366.076 263.18 366.076 260.916Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.547 57.0527H43.7712V61.2276H62.547V57.0527Z",
    fill: "#45A4AE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5625 57.0527H19.7867V61.2276H38.5625V57.0527Z",
    fill: "#45A4AE"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_537_39157)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M220.649 198.099C241.794 181.712 245.768 151.384 229.526 130.361C213.284 109.338 182.976 105.579 161.831 121.967C140.686 138.354 136.712 168.682 152.954 189.705C169.196 210.728 199.504 214.487 220.649 198.099Z",
    fill: "#0A525A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.666 174.754L197.628 159.785L212.716 143.644C214.415 141.827 214.327 138.944 212.52 137.259C210.714 135.573 207.83 135.681 206.131 137.499L191.044 153.639L175.006 138.67C173.199 136.984 170.315 137.093 168.616 138.91C166.917 140.728 167.005 143.61 168.811 145.296L184.849 160.266L169.762 176.406C168.063 178.224 168.151 181.106 169.957 182.792C171.763 184.478 174.647 184.369 176.346 182.552L191.434 166.411L207.472 181.381C209.278 183.066 212.162 182.958 213.861 181.14C215.56 179.323 215.472 176.44 213.666 174.754Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_537_39157"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 376,
    height: 272,
    fill: "white",
    transform: "translate(0 0.929688)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_537_39157"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 96.2003,
    height: 96.8825,
    fill: "white",
    transform: "matrix(0.731043 0.682331 -0.68288 0.730531 189.155 91.8174)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddsubcategoryImage);
export default __webpack_public_path__ + "static/media/addsubcategoryImage.fce458ab6375877172d6c22e68d8ea89.svg";
export { ForwardRef as ReactComponent };